var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgObPhoneCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1DC06F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.975 22.848a.799.799 0 01-.787.697 13.29 13.29 0 01-9.362-3.905 13.291 13.291 0 01-3.905-9.361c-.002-.4.301-.73.697-.787l2.576-.368a.833.833 0 01.884.496l1.294 3.02a.833.833 0 01-.177.917l-.911.912a.78.78 0 00-.185.846 7.454 7.454 0 004.052 4.052.78.78 0 00.847-.184l.911-.912a.833.833 0 01.918-.177l3.019 1.294c.346.149.55.511.497.884l-.368 2.576z",
    fill: "#fff"
  })));
}

export default SvgObPhoneCall;